import { mapMutations, mapState } from 'vuex';
import { validationFormMixin } from '../../../shared/mixins/validationFormMixin';

import {
  fetchIncomeCategory,
  createIncomeCategory,
  updateIncomeCategory,
  deleteIncomeCategory,
} from '../../helpers/KnIncomeOptions';
import { paginationMixin } from '@/modules/shared/mixins/paginationMixin';

import KnFormSubtitle from '../../../shared/components/KnFormSubtitle/KnFormSubtitle.vue';
import KnFormActionButtons from '../../../shared/components/KnFormActionButtons/KnFormActionButtons.vue';
import KnListWithActions from '../../../shared/components/KnListWithActions/KnListWithActions.vue';

export default {
  components: {
    KnFormSubtitle,
    KnFormActionButtons,
    KnListWithActions,
  },
  mixins: [paginationMixin, validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      incomeCategory: {
        id: 'NA', // No asignado
        dato: null,
        id_autor: null,
        id_institucion_educativa: null,
      },
      incomeCategories: [],
      toUpdate: false,
      showInactive: false,
      loading: false,
    };
  },
  async created() {
    this.setIsLogin(false);
    await this.getPaginatedIncomeCategory(1);
    this.incomeCategory.id_autor = this.userData.id;
    this.incomeCategory.id_institucion_educativa = this.institutionId;

    //this.incomeCategories = await fetchIncomeCategoryByEI(this.institutionId);
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Agregar';
    },
    invalidFields() {
      return this.objectHasNulls(this.incomeCategory);
    },
  },
  watch: {
    showInactive: {
      async handler() {
        await this.getPaginatedIncomeCategory(1);
      },
    },
    institutionId: {
      async handler() {
        this.setIsLogin(false);
        await this.getPaginatedIncomeCategory(1);
        this.incomeCategory.id_autor = this.userData.id;
        this.incomeCategory.id_institucion_educativa = this.institutionId;
      },
    },
  },
  methods: {
    ...mapMutations(['setIsLogin']),
    async getPaginatedIncomeCategory(page = 1) {
      try {
        this.incomeCategories = [];
        this.setPaginationPage(page);

        if (!this.loading) {
          this.loading = true;

          const { ok, data, message, count } = await fetchIncomeCategory({
            institutionId: this.institutionId,
            systemStatus: !this.showInactive,
            limit: this.pagination.limit,
            offset: this.pagination.offset,
          });

          if (ok) {
            this.setPaginationCount(count);
            for (const income of data) {
              this.incomeCategories.push({ ...income });
            }
          } else {
            console.error(
              'No se pudieron obtener los ingresos por categoria',
              message
            );
          }

          this.loading = false;
        }
      } catch (error) {
        console.error('Error al obtener los ingresos por categoria:', error);
        this.loading = false;
      }
    },
    async save() {
      await createIncomeCategory(
        this.incomeCategory.dato,
        this.incomeCategory.id_autor,
        this.incomeCategory.id_institucion_educativa
      );
      await this.getPaginatedIncomeCategory(1);
      //this.incomeCategories = await fetchIncomeCategoryByEI(this.institutionId);
      this.clear();
    },
    clear() {
      this.incomeCategory = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    clearInline() {
      this.incomeCategory = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    async updateInline(item) {
      // console.log("updateInline item", item);
      this.incomeCategory = { ...item };
      await updateIncomeCategory(
        this.incomeCategory.id,
        this.incomeCategory.dato,
        this.incomeCategory.id_autor,
        this.incomeCategory.id_institucion_educativa
      );
      await this.getPaginatedIncomeCategory(1);
      //this.incomeCategories = await fetchIncomeCategoryByEI(this.institutionId);
      this.clearInline();
    },
    async deleteInline(itemId) {
      await deleteIncomeCategory(itemId);
      await this.getPaginatedIncomeCategory(1);
      //this.incomeCategories = await fetchIncomeCategoryByEI(this.institutionId);
      this.clearInline();
    },
  },
};
